/* Phase 55.1 — Slug helpers (mirrored from backend `seo_brand_routes.py::slugify`).
 *  - lowercase, accent-stripped, non-alphanum -> "-"
 *  - "Mercedes-Benz" -> "mercedes-benz"
 *  - "Model 3" -> "model-3", "RS Q8" -> "rs-q8"
 */
export function slugify(s) {
  if (!s) return "";
  return String(s)
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/** Localized path prefix for the SEO brand+model URLs.
 *  /de/autos/{brand} · /fr/voitures/{brand} · /it/auto/{brand} · /en/cars/{brand}
 */
export const SEO_BRAND_PATH_BY_LOCALE = {
  de: "autos",
  fr: "voitures",
  it: "auto",
  en: "cars",
};

export function brandSeoPath(locale, brandSlug, modelSlug) {
  const seg = SEO_BRAND_PATH_BY_LOCALE[locale] || SEO_BRAND_PATH_BY_LOCALE.de;
  if (modelSlug) return `/${locale}/${seg}/${brandSlug}/${modelSlug}`;
  return `/${locale}/${seg}/${brandSlug}`;
}
